if (!customElements.get('discount-popup')) {
  customElements.define(
    'discount-popup',
    class DiscountPopup extends HTMLElement {
      constructor() {
        super();
        this.infoButtonMobile = this.querySelector('.discount-popup__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.discount-popup__info');
        this.closeButton = this.querySelector('.button-close');
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo) {
          this.popoverInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.infoButtonMobile.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if (!isExpanded || event.type === 'click') {
          button.setAttribute('aria-expanded', !isExpanded);

          this.popoverInfo.toggleAttribute('hidden');

          button.classList.toggle('discount-popup__info-button--open');

        }

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
          button.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
              this.closePopover(e);
            }
          });
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isPopoverChild = this.popoverInfo.contains(event.relatedTarget);

        const button = this.infoButtonMobile;

        if (!isPopoverChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('discount-popup__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}
